// export const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT || 'http://localhost:3000'

export const API_ENDPOINT = 'https://foodya-mern.herokuapp.com'